module.exports = __webpack_public_path__ + "img/general_guide_image_browser@2x.f7794a8f.png";